const articles = [
  {
    title: 'Uploading Files Into Ruby On Rails ActiveStorage',
    link: 'https://hackernoon.com/uploading-files-into-ruby-on-rails-activestorage-gv1r3ukr',
  },
  {
    title: 'Flexbox Vs. CSS Grid or What Should You Use as Basic CSS Layout',
    link: 'https://hackernoon.com/flexbox-vs-css-grid-or-what-should-you-use-as-basic-css-layout-2aai36fm',
  },
];

export default articles;
